import * as React from 'react';
import { apiMain } from '../App';
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getLanLoc } from '../components/Functions/LangFunc';
import { GetDataPromise, PostDataPromise } from '../components/Functions/SendingData';
import { useState } from 'react';
import { MainData } from '../Data/MainData';
import PageLayout from '../components/Layouts/PageLayout';
import { Dictionery } from '../Data/Dictionery';
import { IconClose } from '../Assets/IconClose';
import styled from 'styled-components';
import { TextInputWTitle } from '../components/Inputs/TextInputWTitle';
import { TextBtn } from '../components/Inputs/TextBtn';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import { havePermission, haveRole } from '../components/Functions/PermissionCheck';
import backgroundImage from "../Assets/login-bg.webp"
import { TextBtn2 } from '../components/Inputs/TextBtn2';
import { IconTick } from '../Assets/panels/IconTick';
import { IconError } from '../Assets/panels/IconError';
const Styles = styled.div`
  height: 100svh;
  display: flex;
  flex-direction: column;
  isolation: isolate;
  position: relative;
  .background {
    z-index: -1;
    position: absolute;
    inset: 0;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
  .column {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .row {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 1rem;
    gap: 0.5rem;
  }
  .links {
    min-width: 100px;
    max-width: 150px;
    background-color: var(--n-grey-0);
    border: 1px solid #E5E5E590;
    border-radius: 1.5rem;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    text-decoration: none;
    color: inherit;
    .title {
      font-size: 1.2rem;
      font-weight: 700;
    }
  }
  .box {
    min-width: 350px;
    max-width: 450px;
    margin: 1rem;
    background-color: var(--n-grey-0);
    border: 1px solid #E5E5E590;
    border-radius: 1.5rem;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    .field {
      display: flex;
      flex-direction: column;
    }
    .title {
      display: flex;
      justify-content: space-between;
      .text {
        font-weight: 600;
      }
      .action {
        cursor: pointer;
      }
    }
    .line {
      height: 1px;
      background-color: #E5E5E5;
    }
    .icon {
      display: flex;
      justify-content: center;
      &.error {
        svg {
          fill: var(--prime-3);
        }
      }
      svg {
        width: 80px;
        height: 80px;
        fill: var(--prime-1);
      }
    }
    .desc {
      text-align: center;
      color: var(--n-grey-2);
    }
    .forget-password {
      margin: 0 0.1rem 0.8rem;
      text-decoration: none;
      font-weight: 700;
      align-self: flex-start;
    }
  }
`

export default function PaymentSuccess(props) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let {isEn: lan, isSet: isSetLan} = getLanLoc(location.pathname);
  let lang=(lan ? MainData.dict[0] : MainData.dict[1])

  if(params.get("status") === "error"){
    return (
      <PageLayout 
        {...props} 
        language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
        dict={MainData.dict} 
        mainLogo={MainData.mainLogo} 
        texts={MainData.texts} 
        nav={MainData.nav} 
        footer={MainData.footer} 
        login={MainData.login}
      >
        <Styles>
          <div className='background'>
            <img src={backgroundImage} alt='background ocean'/>
          </div>
          <div className="navpad"></div>
          <div className='column'>
            <div className='box'>
              <div className='title'>
                <div className='text'>
                  {Dictionery.paymentError[lang.filename]}
                </div>
                <div className='action'>
                </div>
              </div>
              <div className='line'>
              </div>
              <div className='icon error'>
                <IconError/>
              </div>
              <div className='desc'>
                {Dictionery.paymentErrorText[lang.filename]}
              </div>
              {/* <TextBtn2
                newType={3}
                onclick={() => {
                  // navigation("/" + lang.filename + "/login")
                }}
                text={Dictionery.loginSignupBtn[lang.filename]}
              /> */}
            </div>
          </div>
        </Styles>
      </PageLayout>
    )
  }

  return (
    <PageLayout 
      {...props} 
      language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
      dict={MainData.dict} 
      mainLogo={MainData.mainLogo} 
      texts={MainData.texts} 
      nav={MainData.nav} 
      footer={MainData.footer} 
      login={MainData.login}
    >
      <Styles>
        <div className='background'>
          <img src={backgroundImage} alt='background ocean'/>
        </div>
        <div className="navpad"></div>
        <div className='column'>
            <div className='box'>
              <div className='title'>
                <div className='text'>
                  {Dictionery.paymentSuccess[lang.filename]}
                </div>
                <div className='action'>
                </div>
              </div>
              <div className='line'>
              </div>
              <div className='icon'>
                <IconTick/>
              </div>
              <div className='desc'>
                {Dictionery.paymentSuccessText[lang.filename]}
              </div>
              {/* <TextBtn2
                newType={3}
                onclick={() => {
                  // navigation("/" + lang.filename + "/login")
                }}
                text={Dictionery.loginSignupBtn[lang.filename]}
              /> */}
            </div>
          </div>
      </Styles>
    </PageLayout>
  )
}